var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThermometerBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7847 0.687256C8.88759 0.687256 8.16016 1.42529 8.16016 2.33543V13.7097L8.97255 13.3958V2.38394C8.97255 1.92891 9.33611 1.51891 9.7847 1.51891C10.2331 1.51891 10.5969 1.92891 10.5969 2.38394V13.3958L11.4089 13.7096V2.33543C11.4089 1.42526 10.6817 0.687256 9.7847 0.687256Z",
    fill: "#1E2447"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5976 12.917V13.7826C11.4568 14.1148 12.0672 14.9581 12.0672 15.9462C12.0672 17.2251 11.0461 18.2616 9.78543 18.2616C8.52531 18.2616 7.50359 17.2251 7.50359 15.9462C7.50359 14.958 8.11416 14.1148 8.97332 13.7826V12.917C7.65839 13.2789 6.69141 14.4977 6.69141 15.9464C6.69141 17.6805 8.07654 19.0858 9.78547 19.0858C11.4946 19.0858 12.8793 17.6805 12.8793 15.9464C12.8793 14.4977 11.9125 13.279 10.5976 12.917Z",
    fill: "#1E2447"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1812 8.06493C10.1812 7.83862 10.0071 7.65552 9.79278 7.65552H9.77644C9.56218 7.65552 9.3881 7.83866 9.3881 8.06493V14.2053C8.58816 14.3962 7.98828 15.1505 7.98828 16.0509C7.98828 17.0951 8.79406 17.9446 9.78442 17.9446C10.7752 17.9446 11.581 17.0951 11.581 16.0509C11.581 15.1504 10.9812 14.3964 10.1812 14.2053V8.06493Z",
    fill: "#1E2447"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermometerBlue);
export default __webpack_public_path__ + "static/media/Thermometer_Blue.cea83d61.svg";
export { ForwardRef as ReactComponent };